// Shared imports
const { TYPES: modelTypes } = require('shared/model-types')
// Sibling imports
const { withButton } = require('./base')
const { withModelToggle } = require('./model-toggle')

const CapsuleButton = withButton('CapsuleButton')
const CircleButton = withButton('CircleButton')

module.exports = {
  CapsuleButton,
  CircleButton,
  ...createModelToggleButtonComponents({
    CollectionSubscribe: modelTypes.MIX,
    InterestFollow: modelTypes.INTEREST,
    UserFollow: modelTypes.USER
  }, {
    CapsuleButton,
    CircleButton
  })
}

function createModelToggleButtonComponents(modelTypeByName, buttonComponentByName) {
  const result = {}
  for (let modelTypeName in modelTypeByName) {
    const modelType = modelTypeByName[modelTypeName]
    for (let buttonComponentName in buttonComponentByName) {
      const buttonComponent = buttonComponentByName[buttonComponentName]
      const combinedComponentName = `${modelTypeName}${buttonComponentName}`
      result[combinedComponentName] = withModelToggle(modelType, buttonComponent)
    }
  }
  return result
}
